// @core/api/endpoints/platform/get_consent_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConsentStatusResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get consent status
 * Checks whether the current user has granted consent for a specific consent type and federation peer.
 */
export async function GetConsentStatus(
  params?: {
  },
  options?: RequestOptions
): Promise<ConsentStatusResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/federation/consent/status`;
  const requestOptions = options;
  return client.get<ConsentStatusResponse>(requestPath, { ...requestOptions, params });
}
